import { render, staticRenderFns } from "./remain.vue?vue&type=template&id=3ccf67d1&scoped=true"
import script from "./remain.vue?vue&type=script&lang=js"
export * from "./remain.vue?vue&type=script&lang=js"
import style0 from "./remain.vue?vue&type=style&index=0&id=3ccf67d1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccf67d1",
  null
  
)

export default component.exports